exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".import-buttons {\n  margin-top: 10px;\n  text-align: right; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /dist/src/app/import/user-import/user-import.component.scss
// module id = ../../../../../src/app/import/user-import/user-import.component.scss
// module chunks = main